"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_2 = require("@rollbar/react");
var rollbarConfig = {};
exports.wrapRootElement = function (_a, pluginOptions) {
    var element = _a.element;
    rollbarConfig = pluginOptions;
    return react_1.default.createElement(react_2.Provider, { config: rollbarConfig }, element);
};
